import { Link, useLocation } from "react-router";
import { SUB_MOBILE_NAVIGATION } from "@particles/Navigation/utils/constants";
import { cn } from "@util/helpers";

const SubMobileNavigation = () => {
  const location = useLocation();

  const pathname = location.pathname;

  return (
    <div className="flex justify-center gap-4 lg:hidden">
      {SUB_MOBILE_NAVIGATION.map((nav) => {
        const linkParams = new URLSearchParams(nav.trackingData).toString();

        return (
          <div className="group" key={nav.key}>
            <Link
              key={nav.key}
              role="link"
              to={`${nav.link}${linkParams ? `?${linkParams}` : ""}`}
              className={cn(
                "font-poppins font-medium text-gray-515 xs:text-lg",
                {
                  "font-semibold text-gray-850": pathname === nav.link,
                }
              )}
              reloadDocument
            >
              {nav.label}
            </Link>

            <div
              className={cn(
                "mx-auto mt-1 h-[2px] w-[3rem] bg-gray-850 opacity-0 transition-all duration-300",
                "group-hover:opacity-100",
                { "opacity-100": pathname === nav.link }
              )}
            ></div>
          </div>
        );
      })}
    </div>
  );
};

export default SubMobileNavigation;
